import {createStore, applyMiddleware, compose } from 'redux';
import rootReducer from './reducers/reducers.js';
import thunk from 'redux-thunk';
import { routerMiddleware, push } from 'react-router-redux';
import {hashHistory } from 'react-router';

export default function configureStore(initialState) {
	const store = createStore(
		rootReducer,
		initialState,
		compose(
			applyMiddleware(thunk),
			applyMiddleware(routerMiddleware(hashHistory)),
			window.devToolsExtension ? window.devToolsExtension() : f => f
		));
	if (module.hot) {
		module.hot.accept('./reducers/reducers.js', () => {
	      const nextRootReducer = require('./reducers/reducers.js').default
	      store.replaceReducer(nextRootReducer)
		})
  	}
  	return store
}


// WEBPACK FOOTER //
// ./configureStore.js